export default "__VITE_ASSET__DlLqVjje__"